import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import FadeIn from 'react-fade-in/lib/FadeIn';
import { ModalBodyDivider } from '../modal/modal-body-divider';
import { layoutDefaults } from '../../utils/layout-defaults';
import { AddressCard } from './address-card';
import { useGoogleMapsGeocoder } from '../../hooks/use-google-maps-geocoder';

function AddressStreetNumberModalBody({
  config,
  placeDetails,
  baseLocation,
  streetNumber: pStreetNumber,
  onStreetNumberChange,
  noStreetNumber: pNoStreetNumber,
  onNoStreetNumberChange,
  onGeocoderLoaded,
}) {
  const { t } = useTranslation();
  const { isGeocoderLoaded, geocoder } = useGoogleMapsGeocoder();
  const classes = useStyles();

  const [streetNumber, setStreetNumber] = useState(pStreetNumber);
  const [noStreetNumber, setNoStreetNumber] = useState(pNoStreetNumber);

  useEffect(() => {
    onStreetNumberChange?.call(this, streetNumber);
  }, [streetNumber]);

  useEffect(() => {
    if (isGeocoderLoaded) {
      onGeocoderLoaded?.call(this, geocoder);
    }
  }, [isGeocoderLoaded, geocoder]);

  useEffect(() => {
    onNoStreetNumberChange?.call(this, noStreetNumber);
  }, [noStreetNumber]);

  const handleOnStreetNumberChange = (event) => {
    setStreetNumber(event.target.value);
    // onStreetNumberChange?.call(this, event.target.value);
  };

  const hancleOnNoStreetNumberClick = () => {
    setStreetNumber('');
    setNoStreetNumber(!noStreetNumber);
    // onStreetNumberChange?.call(this, '');
    // onNoStreetNumberChange?.call(this, !noStreetNumber);
  };

  return (
    <div className={classes.container}>
      <AddressCard
        config={config}
        placeDetails={placeDetails}
        baseLocation={baseLocation}
        noStreetNumber={noStreetNumber}
      />
      <FadeIn delay={layoutDefaults.keyboardDuration}>
        <Form>
          <div className={classes.label}>
            {t('address-street-number-modal.empty')}:
          </div>
          <Form.Control
            placeholder={t('address-street-number-modal.placeholder')}
            value={streetNumber}
            disabled={noStreetNumber}
            onChange={handleOnStreetNumberChange}
            maxLength={10}
          />
          <ModalBodyDivider
            title={t('divider.or')}
            className={classes.divider}
          />
          <div className={classes.noStreetNumber}>
            <Form.Check
              size="lg"
              className={classes.check}
              checked={noStreetNumber}
              // defaultChecked={noStreetNumber}
              // onClick={hancleOnNoStreetNumberClick}
              onChange={hancleOnNoStreetNumberClick}
            />
            <Button
              variant="link"
              className={classes.link}
              onClick={hancleOnNoStreetNumberClick}
            >
              {t('address-street-number-modal.no-street-number.button')}
            </Button>
          </div>
        </Form>
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginTop: -layoutDefaults.verticalMargin,
    // border: '1px solid red',
  },
  label: {
    color: layoutDefaults.primaryColor,
    display: 'flex',
    // alignSelf: 'left',
    fontSize: layoutDefaults.bigFontSize,
    marginTop: layoutDefaults.biggerVerticalMargin,
    // border: '1px solid red',
  },
  noStreetNumber: {
    display: 'flex',
    // flexDirection: 'row',
    alignItems: 'center',
    marginTop: -layoutDefaults.smallerVerticalMargin,
    // justifyContent: 'center',
    // marginTop: 20,
    // border: '1px solid red',
  },
  check: {
    // alignSelf: 'center',
    marginRight: layoutDefaults.smallHorizontalMargin,
    marginBottom: 6,
  },
  link: {
    cursor: 'pointer',
    fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.linkColor,
    marginLeft: layoutDefaults.smallestHorizontalMargin,
    padding: 0,
    margin: 0,
  },
});

export { AddressStreetNumberModalBody };
